<script setup>
import {computed, defineProps} from 'vue'
import {formatBingToMicrosoftLowercase} from '@shared/utils/helpers'

const props = defineProps({
  platform: {
    type: String,
    required: true,
    default: '',
  },
})

const normalizedPlatform = computed(() =>
  props.platform ? formatBingToMicrosoftLowercase(props.platform || '').toLowerCase() : null,
)
</script>

<template>
  <span v-if="normalizedPlatform" class="platform-icon" :class="`platform-icon--${normalizedPlatform}`" />
  <span v-else class="platform-icon" />
</template>
